module.exports = "../../app/cells/components/modals/question_answer_cell.rb";